import { ApiClient } from "@/api/client/apiClient.ts";
import { inject } from "vue";
import {apiClientKey} from "@/plugins/services.ts";

export function useApiClient(): ApiClient {
    return inject(apiClientKey) as ApiClient;
}
